import type { PlaybookHandler } from './playbook-handler';

export const PlaybookRegistry = Symbol.for('PlaybookRegistry');

/**
 * Playbook 注册表接口
 */
export interface PlaybookRegistry {
    /**
     * 注册 Playbook 处理器
     */
    register(playbookId: string, handler: PlaybookHandler): void;

    /**
     * 获取 Playbook 处理器
     */
    getHandler(playbookId: string): PlaybookHandler | undefined;

    /**
     * 检查是否已注册
     */
    has(playbookId: string): boolean;
}
